var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystemnameicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "System_name_icon",
    "data-name": "System name icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.031,
    height: 25.027,
    viewBox: "0 0 28.031 25.027",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Company_name_icon_",
    "data-name": "Company name icon ",
    d: "M-172.63,371.871V396.81h15.094V371.871Zm6.273,18.525h-3.369v-3.37h3.369Zm0-5.8h-3.369v-3.369h3.369Zm0-5.8h-3.369V375.42h3.369Zm5.826,11.606H-163.9v-3.37h3.369Zm0-5.8H-163.9v-3.369h3.369Zm0-5.8H-163.9V375.42h3.369Zm15.931,4.83V396.9h-3.518v-7h-5.253v7h-3.518V383.62Zm0-2.445h-12.289v1.85H-144.6Z",
    transform: "translate(172.63 -371.871)",
    fill: "#3c3c3b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemnameicon);
export default __webpack_public_path__ + "static/media/System name icon.b0037c5bedd16b538cfee3d128468d4d.svg";
export { ForwardRef as ReactComponent };